(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-sticky-footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const stickyFooter = document.getElementById('sticky-footer');
  const closeButton = document.getElementById('close-footer');
  const ctaButton = document.querySelector('.cta-button');

  // Show the sticky footer after 10 seconds if not already closed in this session
  if (!sessionStorage.getItem('stickyFooterHidden')) {
    setTimeout(function () {
      stickyFooter.classList.remove('hidden'); // Show the sticky footer
    }, 10000); // 10 seconds
  }

  // Close button event
  closeButton.addEventListener('click', function () {
    stickyFooter.classList.add('hidden'); // Hide the sticky footer
    sessionStorage.setItem('stickyFooterHidden', 'true'); // Set the session-specific flag
  });

  // CTA button event
  ctaButton.addEventListener('click', function () {
    sessionStorage.setItem('stickyFooterHidden', 'true'); // Set the session-specific flag
    stickyFooter.classList.add('hidden'); // Hide the sticky footer
  });
});


  
  


  } catch(e) { console.error(e); }
})();
})();
